import React, { useEffect, useState } from 'react';
const NAMES = ['Mariela', 'Laura', 'Carolina', 'Sofía', 'Valentina', 'Andrea', 'Gabriela', 'Patricia', 'Claudia', 'Romina', 'Daniela', 'Florencia', 'Roberto', 'Martín', 'Diego'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'La Plata', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Resistencia', 'Posadas', 'Paraná'];
const TIMES = ['hace 2 min', 'hace 5 min', 'hace 8 min', 'hace 12 min', 'hace 15 min', 'hace 20 min'];
const PACKS = ['Mega Pack Completo', 'Pack Primaria', 'Pack Secundaria'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: '',
    pack: ''
  });
  useEffect(() => {
    if (isDismissed) return;
    let hideTimeout: NodeJS.Timeout;
    const showNewPopup = () => {
      setData({
        name: getRandomItem(NAMES),
        city: getRandomItem(CITIES),
        time: getRandomItem(TIMES),
        pack: getRandomItem(PACKS)
      });
      setIsVisible(true);
      // Hide after 4.5 seconds
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 4500);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showNewPopup();
    }, 2000);
    // Interval for subsequent popups (every 8 seconds)
    const interval = setInterval(() => {
      showNewPopup();
    }, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, [isDismissed]);
  if (isDismissed) return null;
  return <div className={`fixed bottom-4 left-4 right-4 md:right-auto md:w-80 z-50 transition-all duration-500 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-172">
      <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-4 shadow-2xl relative overflow-hidden" data-id="element-173">
        <button onClick={() => {
        setIsVisible(false);
        setTimeout(() => setIsDismissed(true), 500); // Wait for exit animation
      }} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-174">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-175">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-176"></path>
          </svg>
        </button>

        <div className="flex items-start gap-3 pr-4" data-id="element-177">
          {/* Avatar */}
          <div className="w-10 h-10 rounded-full bg-[#5a4a1a] flex items-center justify-center text-[#F5C518] font-black text-sm flex-shrink-0" data-id="element-178">
            {data.name ? data.name.charAt(0) : ''}
          </div>

          <div className="flex-1 min-w-0" data-id="element-179">
            <div className="flex items-center gap-2 mb-1" data-id="element-180">
              <p className="text-white font-bold text-sm truncate" data-id="element-181">
                {data.name} de {data.city}
              </p>
              <span className="relative flex h-2 w-2 flex-shrink-0" data-id="element-182">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-183"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-184"></span>
              </span>
            </div>
            <p className="text-gray-300 text-xs mb-1 leading-snug" data-id="element-185">
              compró el{' '}
              <span className="text-[#F5C518] font-bold" data-id="element-186">{data.pack}</span>
            </p>
            <p className="text-gray-500 text-xs font-medium" data-id="element-187">{data.time}</p>
          </div>
        </div>
      </div>
    </div>;
}